import * as Yup from "yup";
import { validateVerificationCode } from "../common";

export const loginMFASchema = Yup.object().shape({
  code: validateVerificationCode,
});
